const IMG = '/images/catering';

const page = {
  slug: 'catering',
  title: 'Catering',
  hero: {
    title: 'Catering',
    image: `${IMG}/hero.webp`,
  },
  blocks: [
    {
      type: 'split',
      image: `${IMG}/event.webp`,
      imageAlt: 'Multiple small white dishes with fried items garnished with cilantro on metal shelving',
      imageSide: 'right',
      imageAspect: '4 / 3',
      groups: [
        {
          heading: 'Our Approach',
          rule: true,
          paragraphs: [
            [
              'At Square Fare, we pride ourselves on our ability to deliver exceptional upscale food options that are ',
              { bold: 'perfectly suited for any and every occasion you may have.' },
            ],
            "Whether you're hosting a productive morning meeting, or throwing an unforgettable party, our talented team is dedicated to providing you with an impressive array of fresh and delectable culinary creations that are guaranteed to leave your guests feeling absolutely fantastic.",
          ],
        },
      ],
    },
    {
      type: 'split',
      tone: 'warm',
      image: `${IMG}/spread.webp`,
      imageAlt: 'Buffet tray with different types of prepared food, including rice, beef, and possibly chicken, garnished with green onions and herbs',
      imageSide: 'left',
      imageAspect: '4 / 3',
      groups: [
        {
          heading: 'Catering Styles',
          rule: true,
          paragraphs: [
            [
              'We provide an array of dining options tailored to your preferences. Whether you envision a sophisticated ',
              { bold: 'plated event' },
              ', a casual and abundant ',
              { bold: 'buffet-style' },
              ' experience, or ',
              { bold: 'individually portioned meals' },
              ', we have you covered.',
            ],
            "Have a specific cuisine in mind? Or a special request? Don't hesitate to reach out! We look forward to creating a memorable dining experience with you.",
          ],
        },
      ],
    },
    {
      type: 'quote',
      text: 'We worked with Square Fare to cater a high-level meeting with external partners and were impressed with the excellent food and service delivery. We recommend partnering with Chef Mateus especially to those organizations who want to add a personal touch to their corporate events rather than relying on a mainstream, impersonal service. Chef and his team customized the menu for our specific needs. Claire was professional and a pleasure to work with. Delivery was on time and the food delicious. The setup was professional and aesthetically pleasing. Square Fare is now on our list of go-to vendors for future events!',
      image: `${IMG}/testimonial-ranjha.webp`,
      imageAlt: 'Portrait of Muhammad Ranjha',
      variant: 'portrait',
      name: 'Muhammad Ranjha, Special Assistant at',
      link: { label: 'Mayors Migration Council', href: 'https://www.mayorsmigrationcouncil.org' },
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
